import React from "react";
import { Avatar, Box, TableRow, TableCell, Typography } from "@mui/material";
import { formatPhoneNumber } from "../../../util/ValidationUtils";
import PropTypes from "prop-types";
import UserRoleChip from "./UserRoleChip";
import SmsIndicator from "./SmsIndicator";
import UserActionsMenu from "./UserActionsMenu";
import { getRoleChipColors, getUserInitials } from "./userDisplayUtils";

const UsersTableRow = ({ user, onEdit, onDelete, roleBasedOptions, isBuyer }) => {
  const canManage = roleBasedOptions.includes(user.role);
  const roleColors = getRoleChipColors(user.role);

  return (
    <TableRow hover>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
          <Avatar
            sx={{
              width: 30,
              height: 30,
              fontSize: 11,
              fontWeight: 600,
              flexShrink: 0,
              bgcolor: roleColors.bg,
              color: roleColors.color,
            }}
          >
            {getUserInitials(user)}
          </Avatar>
          <Typography variant={'body2'} color={'textPrimary'} sx={{ overflowWrap: 'anywhere' }}>
            {user.username}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography variant={'body2'} color={'textPrimary'} noWrap>
          {`${user.firstName || ''} ${user.lastName || ''}`.trim()}
        </Typography>
      </TableCell>
      <TableCell>
        <UserRoleChip role={user.role} />
      </TableCell>
      <TableCell>
        <Typography
          variant={'body2'}
          color={'textPrimary'}
          sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}
        >
          {formatPhoneNumber(user.phoneNumber)}
        </Typography>
      </TableCell>
      {isBuyer && (
        <TableCell>
          <SmsIndicator user={user} />
        </TableCell>
      )}
      {canManage ? (
        <TableCell align={'right'}>
          <UserActionsMenu user={user} onEdit={onEdit} onDelete={onDelete} />
        </TableCell>
      ) : (
        <TableCell />
      )}
    </TableRow>
  );
};

UsersTableRow.propTypes = {
  user: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  roleBasedOptions: PropTypes.array.isRequired,
  isBuyer: PropTypes.bool,
};

export default UsersTableRow;
